import { Box, SpinnerSettings } from '@lessonup/pins-shared';
import { styled } from '@lessonup/ui-components';
import React from 'react';
import { useEffectivePinComponentSettings, usePinThemeContext } from '../../utils/pinTheme/PinThemeContext';
import { SpinnerDisc } from './SpinnerDisc';
import { SpinnerHighlight } from './SpinnerHighlight';

export interface SpinnerPinComponentProps {
  onClick?: () => void;
  layout: Box;
  settings: SpinnerSettings;
}

const defaultTitles = Array(12).fill('');

export const SpinnerPinComponent: React.FC<SpinnerPinComponentProps> = ({ settings, layout, onClick }) => {
  const { typographies } = usePinThemeContext();
  const spinnerSettings = useEffectivePinComponentSettings('SPINNER', { settings });
  const settingsBackgroundColors = spinnerSettings.sliceColors
    ? Object.values(spinnerSettings.sliceColors).map((v) => v.backgroundColor)
    : [];
  const settingsTextColors = spinnerSettings.sliceColors
    ? Object.values(spinnerSettings.sliceColors).map((v) => v.textColor)
    : [];
  const smallestSize = layout.size.height > layout.size.width ? layout.size.width : layout.size.height;
  return (
    <StyledSpinnerWrapper style={{ width: smallestSize, height: smallestSize, position: 'relative' }} onClick={onClick}>
      <SpinnerDisc
        size={smallestSize}
        segmentTitles={defaultTitles}
        typography={typographies.smallText}
        backgroundColors={settingsBackgroundColors}
        textColors={settingsTextColors}
      />
      <SpinnerHighlight size={smallestSize} sweepTurn={1 / defaultTitles.length} />
    </StyledSpinnerWrapper>
  );
};

const StyledSpinnerWrapper = styled.div`
  cursor: ${(props) => (props.onClick !== undefined ? 'pointer' : 'inherit')};
`;
